import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import ResumoEnvasadora from "./pages/ResumoEnvasadora";
import TvMosaico from "./pages/TvMosaico";
import HistoricoProdutos from "./pages/HistoricoProdutos";
import ConfigAnalise from "./pages/ConfigAnalise";
import ConfigEquipamentos from "./pages/Equipamentos";
import ConfigMotivos from "./pages/Motivos";
import Protected from "./auth/Protected";
import AppGuard from "./auth/AppGuard";

import "./index.css";

export default function App() {
  return (
    <Protected>
      <AppGuard>
        <Routes>
          {/* Rotas que usam o layout com menu lateral */}
          <Route element={<Navbar />}>
            <Route path="/" element={<Navigate to="/ResumoEnvasadora" replace />} />
            <Route path="/ResumoEnvasadora" element={<ResumoEnvasadora />} />
            <Route path="/HistoricoProdutos" element={<HistoricoProdutos />} />
            <Route path="/ConfigAnalise" element={<ConfigAnalise />} />
            <Route path="/Equipamentos" element={<ConfigEquipamentos />} />
            <Route path="/Motivos" element={<ConfigMotivos />} />
          </Route>

          {/* Rota sem menu (TV em tela cheia) */}
          <Route path="/tv-mosaico" element={<TvMosaico />} />
        </Routes>
      </AppGuard>
    </Protected>
  );
}
